import MUIButton from '@mui/material/Button';
import { ButtonProps } from './types';

const Button = (props: ButtonProps) => {
  const { customClasses = {}, children, sx } = props;
  return (
    <MUIButton
      classes={{ ...customClasses }}
      {...props}
      sx={{
        ...sx,
      }}
    >
      {children}
    </MUIButton>
  );
};

Button.defaultProps = {
  children: 'New Button',
  color: 'primary',
  variant: 'contained',
  size: 'medium',
  disabled: false,
  fullWidth: false,
};

export default Button;
